import {cva, VariantProps} from 'cva';
import {OTPInput} from 'input-otp';
import React, {Fragment, useEffect, useRef} from 'react';
import {styles} from '../../Utilities';
import * as css from './RsnOtpInput.css';

type OverrideProps<T, R> = Omit<T, keyof R> & R;
type RsnOtpInputProps = OverrideProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    {
        value: string;
        onChange: (value: string) => void;
        onComplete?: () => unknown;
        maxLength: number;
        issue?: string | boolean | null | undefined;
        children?: undefined;
    }
>;

export function RsnOtpInput({value, onChange, onComplete, maxLength, disabled, issue, ...rest}: RsnOtpInputProps) {
    const isInvalid = !!issue;

    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <div className={cls.outerBox}>
            <OTPInput
                {...rest}
                ref={ref}
                value={value}
                onChange={onChange}
                onComplete={onComplete}
                inputMode='numeric'
                type='text'
                maxLength={maxLength}
                disabled={disabled}
                containerClassName={cls.innerBox}
                // removed weird 40px added to the input and causes overflow issues
                pushPasswordManagerStrategy='none'
                render={({slots}) => (
                    <Fragment>
                        {slots.map(({char, isActive}, idx) => (
                            <RsnOtpCell key={idx} {...{char, isActive, isInvalid, disabled}} />
                        ))}
                    </Fragment>
                )}
            />
            {issue && <div className={cls.issueText}>{issue}</div>}
        </div>
    );
}

function RsnOtpCell({
    char,
    isActive = false,
    isInvalid = false,
    disabled = false,
}: VariantProps<typeof cls.cell> & {char: string | null}) {
    if (disabled) {
        isActive = isInvalid = false;
    }
    return <div className={cls.cell({isActive, isInvalid, disabled})}>{char}</div>;
}

const cls = styles({
    outerBox: 'relative grid gap-2',
    innerBox: 'flex gap-2',
    issueText: 'fv-text-m absolute left-0 top-full pt-1 text-danger-30',
    cell: cva(css.cell, {
        variants: css.cellVariants,
    }),
});
